<template>
    <div class="p-8 md:p-20 md:px-44 lg:px-72">
        <div class="grid grid-cols-1 py-10">
            <img class="justify-self-center" src="../assets/images/404empty.png" alt="">
            <div class="justify-self-center"><img src="../assets/images/404.png" alt=""></div>
            <div class="justify-self-center font-bold text-xl">Oops!, Page not Found</div>
            <div class="justify-self-center py-5 text-center">Oops! It seems like you've stumbled upon an empty space. The page you are looking for doesn't exist. <br> Looks like you are a lost sheep (Matthew 18 : 12 - 13). <br>Let the Shepherd find you!</div>
            <RouterLink to="/" class="justify-self-center">
                <PrimaryButton content="Go to home page"/>
            </RouterLink>
        </div>
    </div>
</template>

<script setup>
import PrimaryButton from '../components/PrimaryButton.vue';
</script>

<style scoped>

</style>